import classNames from "classnames";
import React from "react";
import { useLocation, useNavigate, useResolvedPath } from "react-router-dom";

import { Tab } from "./types";

type Props = { tab: Tab };

export const NavigationTab: React.FC<Props> = ({ tab }) => {
  const navigate = useNavigate();

  const resolved = useResolvedPath(tab.link);
  const location = useLocation();
  const linkPath = resolved.pathname.split("/").filter((item) => item !== "");
  const locationPath = location.pathname
    .split("/")
    .filter((item) => item !== "");

  const match = linkPath.every((element) => locationPath.includes(element));

  return (
    <div
      onClick={() => navigate(tab.link)}
      className={classNames(
        // Same look as the Work page tabs (Active Work / My Work): 14.5px bold,
        // purple underline on the open tab.
        "-mb-px cursor-pointer border-b-2 pb-3 text-[14.5px] font-bold transition-colors duration-200 max-md:shrink-0 max-md:whitespace-nowrap",
        match
          ? "border-[#6B4EFF] text-[#6B4EFF]"
          : "border-transparent text-[#6F7688] hover:text-[#1F2433]",
      )}>
      {tab.tab}
    </div>
  );
};
